<template>
  <div>
    <Titulo texto="SISTEMA DE ADMISIÓN ESCOLAR" />

    <div v-if="respuestaResultado">
      <Cargando :tamanio="150" />
    </div>
    <div v-else>
      <PostulacionValida
        :nombreCompleto="postulante.nombreCompleto"
        :nivel="postulante.curso"
        :fechaPostulacion="fechaPostulacion"
        v-if="resultadoValido"
        :resultado="true"
      >
        <b-button
          @click.prevent="descargaResultado"
          class="btn btn-lg btn-azul-oscuro2 mt-4 gilmer text-uppercase font-weight-bold"
        >
          Descargar Comprobante
          <FontAwesomeIcon icon="download" class="ml-2" />
        </b-button>
      </PostulacionValida>
      <PostulacionInvalida v-else :resultado="true" />
    </div>
  </div>
</template>

<script>
import Titulo from "@/components/generales/Titulo";
import Cargando from "@/components/generales//modales/Cargando";
import PostulacionValida from "@/components/generales/postulacion/Valida";
import PostulacionInvalida from "@/components/generales/postulacion/Invalida";
import ApiResultado from "@/service/ApiResultado.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faDownload);

export default {
  name: "ValidarResultado",
  components: {
    Titulo,
    Cargando,
    PostulacionValida,
    PostulacionInvalida,
    FontAwesomeIcon
  },
  data() {
    return {
      jwt: "",
      resultadoData: {},
      respuestaResultado: false,
      resultadoValido: true,
      postulante: {
        nombreCompleto: "",
        curso: ""
      },
      fechaPostulacion: ""
    };
  },
  beforeMount() {
    this.comprobarJWT();
  },
  methods: {
    comprobarJWT() {
      this.jwt = this.$route.query.resultado;
      if (this.jwt && this.jwt !== "") {
        this.validarComprobante();
      } else {
        if (this.jwt) {
          this.resultadoNoValido();
        } else {
          this.$emit(
            "onError",
            "Ha ocurrido un error en el proceso. Vuelva a intentarlo.",
            "",
            true,
            "Sae",
            "SISTEMA DE ADMISIÒN ESCOLAR"
          );
        }
      }
    },
    async validarComprobante() {
      //let datosPostulacion = await ApiComprobante.validarComprobantePrueba();
      let datosResultado = await ApiResultado.validarResultado(this.jwt, this);
      if (datosResultado) {
        this.resultadoValidado(datosResultado);
      } else {
        this.resultadoNoValido();
      }
    },
    descargaResultado() {
      this.$router.push({
        name: "DescargarResultado",
        params: {
          datos: this.resultadoData
        },
        query: {
          resultado: this.jwt
        }
      });
    },
    resultadoNoValido() {
      this.respuestaResultado = false;
      this.resultadoValido = false;
    },
    resultadoValidado(datos) {
      this.respuestaResultado = false;
      this.resultadoValido = true;
      this.postulante.nombreCompleto = `${datos.postulante.nombres} ${
        datos.postulante.paterno
      } ${datos.postulante.materno ? datos.postulante.materno : ""}`;
      this.postulante.curso = `${datos.postulante.glosaNivel}`;
      this.fechaPostulacion = datos.fechaModificacion;
      this.resultadoData = datos;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/resultados/Validar.vue